import { cancelFrame, frame } from '../frameloop/frame.mjs';

function subscribeValue(inputValues, outputValue, getLatest) {
  var update = function update() {
    return outputValue.set(getLatest());
  };

  var scheduleUpdate = function scheduleUpdate() {
    return frame.preRender(update, false, true);
  };

  var subscriptions = inputValues.map(function (v) {
    return v.on("change", scheduleUpdate);
  });
  outputValue.on("destroy", function () {
    subscriptions.forEach(function (unsubscribe) {
      return unsubscribe();
    });
    cancelFrame(update);
  });
}

export { subscribeValue };